export const regions = {
  north: "North",
  south: "South",
  east: "East",
  west: "West",
  central: "Central",
};

export const regionsList = Object.values(regions);
